import * as swcHelpers from '@swc/helpers';
import { useLink, useLocation } from '@grandvisionhq/frk-routing';
import { sha256 } from '@grandvisionhq/lib-utils-w3c';

const useRedirects = ({ message  } = {})=>{
    const loginPageLink = useLink({
        route: 'returns',
        params: {
            message
        }
    });
    const confirmationPageLink = useLink({
        route: 'returns.confirmation',
        params: {
            email: '',
            orderNumber: ''
        }
    });
    const { push  } = useLocation();
    const redirectToLogin = ()=>{
        const fallbackRoute = `/returns${message ? `?message=${message}` : ''}`;
        var ref;
        const location = (ref = loginPageLink === null || loginPageLink === void 0 ? void 0 : loginPageLink.href) !== null && ref !== void 0 ? ref : fallbackRoute;
        push(location);
        return;
    };
    const redirectToConfirmation = function() {
        var _ref = swcHelpers.asyncToGenerator(function*(params) {
            const hashedEmail = yield sha256(params.email.toLowerCase());
            const fallbackRoute = `/returns/confirmation?email=${hashedEmail}&orderNumber=${params.orderNumber}`;
            var ref;
            const location = (ref = confirmationPageLink === null || confirmationPageLink === void 0 ? void 0 : confirmationPageLink.href) !== null && ref !== void 0 ? ref : fallbackRoute;
            push(location);
            return;
        });
        return function redirectToConfirmation(params) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        redirectToLogin,
        redirectToConfirmation
    };
};

export { useRedirects };
//# sourceMappingURL=use-redirects.js.map
